import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers } from "vue";
const _hoisted_1 = {
  class: "login-shell"
};
const _hoisted_2 = {
  key: 0,
  class: "login-error"
};
const _hoisted_3 = {
  class: "login-footer"
};
const _hoisted_4 = {
  class: "login-actions"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_b_form_input = _resolveComponent("b-form-input");
  const _component_b_form_invalid_feedback = _resolveComponent("b-form-invalid-feedback");
  const _component_b_form_group = _resolveComponent("b-form-group");
  const _component_router_link = _resolveComponent("router-link");
  const _component_b_button = _resolveComponent("b-button");
  const _component_b_overlay = _resolveComponent("b-overlay");
  const _component_b_modal = _resolveComponent("b-modal");
  const _component_b_container = _resolveComponent("b-container");
  return _openBlock(), _createBlock(_component_b_container, {
    fluid: "",
    class: "login-modal-wrap m-0 p-0"
  }, {
    default: _withCtx(() => [_createVNode(_component_b_modal, {
      modelValue: _ctx.showModal,
      "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => _ctx.showModal = $event),
      "no-footer": "",
      "no-header": "",
      centered: "",
      "modal-class": "modern-login-modal",
      "content-class": "modern-login-content",
      "body-class": "modern-login-body",
      busy: _ctx.loading,
      onHidden: $options.close
    }, {
      default: _withCtx(() => [_createVNode(_component_b_overlay, {
        show: _ctx.loading,
        rounded: "sm"
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_cache[17] || (_cache[17] = _createElementVNode("div", {
          class: "login-top"
        }, [_createElementVNode("div", {
          class: "login-icon"
        }, [_createElementVNode("svg", {
          viewBox: "0 0 24 24",
          fill: "none",
          stroke: "currentColor",
          "stroke-width": "1.8"
        }, [_createElementVNode("rect", {
          x: "3",
          y: "11",
          width: "18",
          height: "10",
          rx: "2"
        }), _createElementVNode("path", {
          d: "M7 11V7a5 5 0 0 1 10 0v4"
        })])]), _createElementVNode("h3", null, "Welcome Back"), _createElementVNode("p", null, "Log in to your account to continue.")], -1)), _createElementVNode("form", {
          onSubmit: _cache[8] || (_cache[8] = _withModifiers($event => $options.login(), ["prevent"])),
          action: ""
        }, [_createVNode(_component_b_form_group, {
          class: "modern-form-group"
        }, {
          default: _withCtx(() => [_cache[11] || (_cache[11] = _createElementVNode("label", null, [_createElementVNode("b", null, "Username or Email")], -1)), _createVNode(_component_b_form_input, {
            modelValue: _ctx.user.username,
            "onUpdate:modelValue": [_cache[0] || (_cache[0] = $event => _ctx.user.username = $event), _cache[2] || (_cache[2] = $event => _ctx.message = '')],
            type: "text",
            class: "modern-input",
            state: _ctx.$v.user.username.$error || _ctx.message !== '' ? false : null,
            onBlur: _cache[1] || (_cache[1] = $event => _ctx.$v.user.username.$touch()),
            autocomplete: "username",
            placeholder: "Enter your username or email"
          }, null, 8, ["modelValue", "state"]), _ctx.$v.user.username.$error ? (_openBlock(), _createBlock(_component_b_form_invalid_feedback, {
            key: 0
          }, {
            default: _withCtx(() => [...(_cache[10] || (_cache[10] = [_createTextVNode(" Username or email is required ", -1)]))], undefined, true),
            _: 1
          })) : _createCommentVNode("", true)], undefined, true),
          _: 1
        }), _createVNode(_component_b_form_group, {
          class: "modern-form-group"
        }, {
          default: _withCtx(() => [_cache[13] || (_cache[13] = _createElementVNode("label", null, [_createElementVNode("b", null, "Password")], -1)), _createVNode(_component_b_form_input, {
            modelValue: _ctx.user.password,
            "onUpdate:modelValue": [_cache[3] || (_cache[3] = $event => _ctx.user.password = $event), _cache[5] || (_cache[5] = $event => _ctx.message = '')],
            type: "password",
            class: "modern-input",
            state: _ctx.$v.user.password.$error || _ctx.message !== '' ? false : null,
            onBlur: _cache[4] || (_cache[4] = $event => _ctx.$v.user.password.$touch()),
            autocomplete: "current-password",
            placeholder: "Enter your password"
          }, null, 8, ["modelValue", "state"]), _ctx.$v.user.password.$error ? (_openBlock(), _createBlock(_component_b_form_invalid_feedback, {
            key: 0
          }, {
            default: _withCtx(() => [...(_cache[12] || (_cache[12] = [_createTextVNode(" Password is required ", -1)]))], undefined, true),
            _: 1
          })) : _createCommentVNode("", true)], undefined, true),
          _: 1
        }), _ctx.message !== '' ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_ctx.message), 1)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_3, [_createVNode(_component_router_link, {
          to: "/forgot/",
          onClick: _cache[6] || (_cache[6] = $event => $options.close()),
          class: "forgot-link"
        }, {
          default: _withCtx(() => [...(_cache[14] || (_cache[14] = [_createTextVNode(" Forgot your password or username? ", -1)]))], undefined, true),
          _: 1
        }), _createElementVNode("div", _hoisted_4, [_createVNode(_component_b_button, {
          onClick: _cache[7] || (_cache[7] = $event => $options.close()),
          class: "btn-login-secondary",
          disabled: _ctx.loading
        }, {
          default: _withCtx(() => [...(_cache[15] || (_cache[15] = [_createTextVNode(" Close ", -1)]))], undefined, true),
          _: 1
        }, 8, ["disabled"]), _createVNode(_component_b_button, {
          class: "btn-login-primary",
          type: "submit",
          disabled: _ctx.loading || _ctx.$v.$invalid
        }, {
          default: _withCtx(() => [...(_cache[16] || (_cache[16] = [_createTextVNode(" Log In ", -1)]))], undefined, true),
          _: 1
        }, 8, ["disabled"])])])], 32)])], undefined, true),
        _: 1
      }, 8, ["show"])], undefined, true),
      _: 1
    }, 8, ["modelValue", "busy", "onHidden"])], undefined, true),
    _: 1
  });
}